import get from 'lodash.get';

const getUserFeatures = (rootState) => get(rootState, 'user.userFeatures', null);

export default getUserFeatures;
